import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { spacing16, spacing8 } from "@churchofjesuschrist/eden-style-constants";

// See Table CSS for the --eden-table-density-divisor custom property.
import { jsx as _jsx } from "react/jsx-runtime";
const Root = styled.td.withConfig({
  componentId: "sc-8selpg-0"
})(["padding:calc( ", " / var(--eden-table-density-divisor,1) ) calc(", " / var(--eden-table-density-divisor,1));text-align:", ";"], _ref => {
  let {
    dataType
  } = _ref;
  return dataType === "controls" ? spacing8 : spacing16;
}, spacing16, _ref2 => {
  let {
    dataType
  } = _ref2;
  return dataType === "number" ? "end" : "start";
});

/** Represents a data cell in a table. */
export default function TD(_ref3) {
  let {
    children,
    type = "normal",
    ...props
  } = _ref3;
  return /*#__PURE__*/_jsx(Root, {
    ...props,
    dataType: type,
    role: "cell",
    children: children
  });
}
TD.propTypes = {
  /** The cell contents. */
  children: PropTypes.node,
  /** The data type of the cell where "controls" would be buttons, form fields, etc. Formatting, such as spacing and text alignment, is automatically applied. */
  type: PropTypes.oneOf(["controls", "normal", "number"])
};